const errorMessage = (message) => (typeof message === 'string' ? message : JSON.stringify(message))

export const checkBfaResponse = async (response) => {
  let body = response?.data
  if (typeof Blob !== 'undefined' && body instanceof Blob && /json|text/.test(body.type)) {
    body = await body.text()
  }
  if (typeof body === 'string') {
    try {
      body = JSON.parse(body)
    } catch (_) {
      return response
    }
  }
  // The existing backend advice can return exception envelopes with HTTP 200.
  if (body && typeof body === 'object' && 'code' in body && 'message' in body) {
    const error = new Error(errorMessage(body.message) || 'The BFA request failed')
    error.response = { ...response, data: { ...body, message: error.message } }
    throw error
  }
  return response
}
